"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueAreas = void 0;
const dayjs = require("dayjs");
const getUniqueAreas = (areas, hotels, region_courses) => {
    const transfer_rate_matrix = [];
    const unique_areas = hotels
        .filter((x) => {
        if (!x.contracts)
            return false;
        return (x.contracts.filter((c) => {
            return c.end_date >= dayjs().format("YYYY-MM-DD");
        }).length > 0);
    })
        .map((h) => {
        return { ...h.transfer_area, type: "Hotel" };
    });
    const hotel_transfer_areas = unique_areas.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
    // loop through each hotel_Transfer_area
    hotel_transfer_areas.map((x) => {
        transfer_rate_matrix.push(x);
    });
    hotels.map((h) => {
        transfer_rate_matrix.push({
            id: h.id,
            name: h.name,
            type: "Hotel",
        });
    });
    region_courses.map((c) => {
        transfer_rate_matrix.push({
            id: c.id,
            name: c.name,
            type: "Course",
        });
    });
    areas.map((a) => {
        transfer_rate_matrix.push({
            id: a.id,
            name: a.name,
            type: a.type,
        });
    });
    return transfer_rate_matrix.map((x) => x.id);
};
exports.getUniqueAreas = getUniqueAreas;
